import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useLocation, useParams } from "react-router-dom";
// import InstructorSidebar from "../instructor/sidebar/index";
import '../Journal/journal.css'
import './volume-page.css'
import Footer from "../footer";
import html from '../../assets/img/html.svg'
import pdf from "../../assets/img/PDF_32.png"
import {
    NetIcon01,
    NetIcon02,
    NetIcon03,
    NetIcon04
} from '../imagepath'
import { useDispatch, useSelector } from "react-redux";
import { ArticlegetByArticleId } from "../../Redux/Articles/articleSlice";
import CourseHeader from "../header/index";
import Bannerpage from "../Banner";
import StudentSideBar from "../student/sidebar";
import axios from "axios";
// import queryString from 'query-string';

const volumePage = () => {
    const { name, slug } = useParams();

    const { articleByarticleId } = useSelector((state) => state.articleData)
    console.log(articleByarticleId, 'vghvsadhdcsd');
    console.log(slug, 'ghvsdhgvdsd');

    const formatVolumeName = (name) => {
        const parts = name.split('-');
        if (parts.length === 5 && parts[0] === 'Volume' && parts[2] === 'Issue') {
            return `Volume ${parts[1]} Issue ${parts[3]}, ${parts[4]}`;
        }
        return name;
    }

    const [article, setArticle] = useState({})
    console.log(article, "artld")

    const articleDetails = articleByarticleId?.data?.[0]?.slug
    console.log(articleDetails, "articleDetails")

    const getArchiveDetailesBySlug = () => {
        axios.get(`${process.env.REACT_APP_URL}/articleDetails/${articleDetails}`)
            .then((res) => {
                console.log(res?.data)
                setArticle(res?.data?.data?.[0])
            })
            .catch((err) => {
                console.log(err)
            })
    }

    useEffect(() => {
        // dispatch(SpissuesgetById(slug));
        getArchiveDetailesBySlug()
    }, [])

    // Example:
    const formatted = formatVolumeName(name);
    console.log(formatted, 'xgascvghsccs');

    const location = useLocation()
    console.log(location, "lcnss")

    const [year, setYear] = useState('');

    useEffect(() => {
        if (location?.state?.data) {
            setYear(location.state.data);
        }
    }, [location?.state?.data]);


    const dispatch = useDispatch();

    // useEffect(() => {
    //     dispatch(ArticlegetByArticleId(window.atob(id), year));
    // }, [])

    useEffect(() => {
        if (year) {
            dispatch(ArticlegetByArticleId(location?.state?.uuid, year));
        }
    }, [dispatch, location?.state?.uuid, year]);

    // Affiliation mapping logic - create for each article
    const getAffiliationMap = (article) => {
        const affiliationMap = new Map();
        article?.authors?.forEach((author) => {
            author?.author_anchor_affiliation?.forEach((affiliation) => {
                const key = `${affiliation?.department}|${affiliation?.university_name_1}|${affiliation?.country}`;
                if (!affiliationMap.has(key)) {
                    affiliationMap.set(key, { number: affiliationMap.size + 1, affiliation });
                }
            });
        });
        console.log('Affiliation Map:', Array.from(affiliationMap.entries()));
        return affiliationMap;
    };

    return (
        <>
            <div className="main-wrapper">
                <CourseHeader activeMenu={"CourseDetails"} />
                {/* <div className="breadcrumb-bar">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 col-12">
                                <div className="breadcrumb-list">
                                    <nav aria-label="breadcrumb" className="page-breadcrumb">
                                        <ol className="breadcrumb">
                                            <li className="breadcrumb-item">
                                                <Link to="/">Home</Link>
                                            </li>
                                            <li className="breadcrumb-item" aria-current="page">
                                                Courses
                                            </li>
                                            <li className="breadcrumb-item" aria-current="page">
                                                All Courses
                                            </li>
                                            <li className="breadcrumb-item" aria-current="page">
                                                The Complete Web Developer Course 2.0
                                            </li>
                                        </ol>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                <Bannerpage name={slug} />
                <div className="container-fluid mt-3 p-2 volume-page-container">
                    <Row>
                        <StudentSideBar activeMenu="Courses" />
                        <Col lg={8} md={8} sm={12} xs={12} style={{ backgroundColor: "#fff" }}>

                            <div className="row p-3">
                                {/* Instructor List */}
                                <div>
                                    <h1 className="volume-title">{formatted}</h1>
                                    {articleByarticleId?.data?.map((article, index) => (
                                        <div key={index} className="article-container">
                                            <Row className="article-header-row">
                                                <Col xs={6} sm={6} md={6} lg={6}>
                                                    <div className="article-type">
                                                        {String(article?.article_types?.[0]?.name).charAt(0).toUpperCase() + String(article?.article_types?.[0]?.name).slice(1)}
                                                    </div>
                                                </Col>
                                                <Col xs={6} sm={6} md={6} lg={6}>
                                                    <div className="page-info" style={{ textAlign: 'right' }}>
                                                        Pages: {article?.start_page_number} - {article?.end_page_number}
                                                    </div>
                                                </Col>
                                                                                         </Row>
                                             <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap',marginTop:"-8px",marginBottom:"-15px" }}>
                                                <div style={{ flex: '1', minWidth: '0' }}>
                                                    {/* <p ><strong>{getNameById(article.article_types, article.article_type_uuid)}</strong></p> */}
                                                    <Link
                                                        to={`/${slug}/archive/${article?.slug}`}
                                                        state={"article"}
                                                        onClick={() => window.scrollTo(0, 0)}
                                                    >
                                                        <h5 className="article-title">{article.article_title}</h5>
                                                    </Link>
                                                    <p className="author-list">
                                                        {(() => {
                                                            const affiliationMap = getAffiliationMap(article);
                                                            return article?.authors?.map((item, indexData) => {
                                                                const hasAffiliations = item?.author_anchor_affiliation?.length > 0;
                                                                const isCorresponding = item?.author_type === "corresponding";
                                                                console.log('Author:', item.author_name, 'hasAffiliations:', hasAffiliations, 'isCorresponding:', isCorresponding, 'affiliations:', item?.author_anchor_affiliation);
                                                                return (
                                                                    <Link
                                                                        key={indexData}
                                                                        to={`/${slug}/author/${article?.slug}/archive`}
                                                                        state={{ author: item }}
                                                                        onClick={() => window.scrollTo(0, 0)}
                                                                    >
                                                                        <em>
                                                                            {item?.author_name}
                                                                            {hasAffiliations && (() => {
                                                                                const supNumbers = new Set();

                                                                                item?.author_anchor_affiliation?.forEach((affiliationItem) => {
                                                                                    const key = `${affiliationItem?.department}|${affiliationItem?.university_name_1}|${affiliationItem?.country}`;
                                                                                    const affiliationData = affiliationMap.get(key);
                                                                                    console.log('Affiliation key:', key, 'affiliationData:', affiliationData);
                                                                                    if (affiliationData) {
                                                                                        supNumbers.add(affiliationData.number);
                                                                                    }
                                                                                });

                                                                                const numbersArray = Array.from(supNumbers).sort((a, b) => a - b);
                                                                                console.log('Numbers array for', item.author_name, ':', numbersArray);
                                                                                return numbersArray.length > 0 ? (
                                                                                    <sup>
                                                                                        <em>{numbersArray.join(",")}</em>
                                                                                    </sup>
                                                                                ) : null;
                                                                            })()}
                                                                            {isCorresponding && <sup>*</sup>}
                                                                            {indexData < article?.authors?.length - 1 && ', '}
                                                                        </em>
                                                                    </Link>
                                                                );
                                                            });
                                                        })()}
                                                    </p>
                                                    {article.doi && article.doi.trim() !== '' && (
                                                        <p className="doi-text">
                                                            DOI:{' '}
                                                            <Link
                                                                to={`/${slug}/archive/${article?.slug}`}
                                                                state="article"
                                                                onClick={() => window.scrollTo(0, 0)}
                                                            >
                                                                {article.doi}
                                                            </Link>
                                                        </p>
                                                    )}

                                                </div>
                                                {/* <div style={{ textAlign: 'right' }}>
                                                <p>Pages: {article.pages}</p>
                                            </div> */}
                                            </div>
                                            <div className="action-buttons">
                                                <div className="left-buttons">
                                                    {article?.article_access_types === 'open access' ? (
                                                        <Link
                                                            to={`/${slug}/archive/${article?.slug}`}
                                                            state={"article"}
                                                        // target="_blank"
                                                        onClick={() => window.scrollTo(0, 0)}
                                                        >
                                                            <img src={html} alt="html" className="icon-size" />
                                                        </Link>
                                                    ) : (
                                                        <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                                            <img src={html} alt="html" className="icon-size" />
                                                        </span>
                                                    )}
                                                    {article?.article_access_types === 'open access' ? (
                                                        <Link
                                                            to={article?.pdf_url}
                                                        // target="_blank"
        
                                                        >
                                                            <img src={pdf} alt="pdf" className="icon-size" />
                                                        </Link>
                                                    ) : (
                                                        <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                                                            <img src={pdf} alt="pdf" className="icon-size" />
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="right-buttons">
                                                    <span className="share-text">Share this article</span>
                                                    <a 
                                                        href="https://www.google.com/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="Google"
                                                    >
                                                        <img src={NetIcon01} alt="Google" className="icon-size" />
                                                    </a>
                                                    <a 
                                                        href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="Share on Facebook"
                                                    >
                                                        <img src={NetIcon02} alt="facebook" className="icon-size" />
                                                    </a>
                                                    <a 
                                                        href="https://github.com/"
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="View on GitHub"
                                                    >
                                                        <img src={NetIcon03} alt="GitHub" className="icon-size" />
                                                    </a>
                                                    <a 
                                                        href={`https://twitter.com/intent/tweet?url=${encodeURIComponent(window.location.href)}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        title="Share on X (Twitter)"
                                                    >
                                                        <img src={NetIcon04} alt="X (Twitter)" className="icon-size" />
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </Col>

                    </Row>
                </div>
                <Footer />
            </div>
        </>
    )
}

export default volumePage